import {
  CAT_RUNNING_GRAVITY,
  CAT_RUNNING_GROUND_Y,
  CAT_RUNNING_INITIAL_SPEED,
  CAT_RUNNING_JUMP_VELOCITY,
  CAT_RUNNING_MAX_SPEED,
  CAT_RUNNING_RUN_FRAME_MS,
  CAT_RUNNING_SPEED_GAIN_PER_SEC,
} from '../../constants'
import { getStageKeyAtDistance } from '../stages'

export const updateSpeedAndDistance = (world, deltaSec) => {
  world.elapsedMs += deltaSec * 1000
  world.speed = Math.min(
    CAT_RUNNING_MAX_SPEED,
    CAT_RUNNING_INITIAL_SPEED + (world.elapsedMs / 1000) * CAT_RUNNING_SPEED_GAIN_PER_SEC,
  )
  world.distance += (world.speed * deltaSec) / 20
  world.stageKey = getStageKeyAtDistance(world.startStageKey, world.distance)
}

export const updatePlayerAnimation = (world, runFrameCount) => {
  world.player.frameIndex = Math.floor(world.elapsedMs / CAT_RUNNING_RUN_FRAME_MS) % runFrameCount
}

export const updatePlayerPhysics = (world, deltaSec) => {
  world.player.previousY = world.player.y
  world.player.velocityY += CAT_RUNNING_GRAVITY * deltaSec
  world.player.y += world.player.velocityY * deltaSec

  if (world.player.y >= CAT_RUNNING_GROUND_Y) {
    world.player.y = CAT_RUNNING_GROUND_Y
    world.player.velocityY = 0
    world.player.isGrounded = true
  }
}

export const updatePlayerJump = (world) => {
  if (!world.player.isGrounded || world.status !== 'running') return

  world.player.isGrounded = false
  world.player.velocityY = CAT_RUNNING_JUMP_VELOCITY
}
